module.exports = __webpack_public_path__ + "media/images/brands/lilica_e_tigor-cade21d52bca8dd9bd3275c3e9caee47.png";